import { Controller } from "@hotwired/stimulus"

// Simple fade carousel: auto-advances, supports prev/next and indicator dots.
export default class extends Controller {
  static targets = ["slide", "dot"]
  static values  = { interval: { type: Number, default: 6000 } }

  connect() {
    this.index = 0
    this._show(this.index)
    this._start()
  }

  disconnect() {
    this._stop()
  }

  next() { this._goto(this.index + 1) }
  prev() { this._goto(this.index - 1) }

  jump(event) {
    const i = parseInt(event.currentTarget.dataset.index, 10)
    if (!isNaN(i)) this._goto(i)
  }

  _goto(i) {
    const n = this.slideTargets.length
    this.index = ((i % n) + n) % n
    this._show(this.index)
    this._restart()
  }

  _show(i) {
    this.slideTargets.forEach((el, idx) => {
      el.classList.toggle("opacity-100", idx === i)
      el.classList.toggle("opacity-0",   idx !== i)
      el.classList.toggle("pointer-events-none", idx !== i)
    })
    if (this.hasDotTarget) {
      this.dotTargets.forEach((el, idx) => {
        el.classList.toggle("bg-white",    idx === i)
        el.classList.toggle("bg-white/40", idx !== i)
      })
    }
  }

  _start()   { this.timer = setInterval(() => this.next(), this.intervalValue) }
  _stop()    { clearInterval(this.timer) }
  _restart() { this._stop(); this._start() }
}
